import { render, staticRenderFns } from "./seller_orders.vue?vue&type=template&id=70f97edc&"
import script from "./seller_orders.vue?vue&type=script&lang=js&"
export * from "./seller_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports